import { Directive, inject } from '@angular/core';
import { OrderFacade } from '@zero/order/domain';

@Directive()
export class CanceledOrdersListBase {
  public readonly orderFacade = inject(OrderFacade);

  public loadOrders(force = false) {
    return this.orderFacade.loadCanceledOrders(force);
  }

  public loadNextPage() {
    return this.orderFacade.incrementCanceledOrdersPage();
  }
}
